/**
 * Cálculo de la inversión (USD) de contrataciones y campañas.
 *
 * Cada contratación/campaña tiene un `price` que aplica por piso de venta, y
 * `storePrices` con los pisos cuyo precio fue ajustado a mano. La inversión total
 * es la suma del precio de cada piso asignado.
 */

/** Id de un piso, venga poblado o como ObjectId. */
export function storeIdOf(store) {
    if (!store) return '';
    return String(typeof store === 'object' ? store._id : store);
}

/** Ids de los pisos asignados a la contratación/campaña. */
export function getStoreIds(entity) {
    return (entity?.stores || []).map(storeIdOf).filter(Boolean);
}

/** Mapa storeId -> precio ajustado a mano. */
export function getStorePriceMap(entity) {
    const map = new Map();
    (entity?.storePrices || []).forEach((entry) => {
        const id = storeIdOf(entry?.store);
        if (id) map.set(id, Number(entry.price) || 0);
    });
    return map;
}

/** Precio de un piso: el ajustado a mano o, en su defecto, el precio general. */
export function getStorePrice(entity, storeId, priceMap = null) {
    const map = priceMap || getStorePriceMap(entity);
    const id = storeIdOf(storeId);
    if (map.has(id)) return map.get(id);
    return Number(entity?.price) || 0;
}

/**
 * Inversión total. Si se pasa `storeIds` solo se suman esos pisos (usado para
 * que los totales respeten los filtros de canal / cliente / PDV).
 */
export function getTotalInvestment(entity, storeIds = null) {
    const priceMap = getStorePriceMap(entity);
    const ids = storeIds ? storeIds.map(storeIdOf) : getStoreIds(entity);
    return ids.reduce((total, id) => total + getStorePrice(entity, id, priceMap), 0);
}
